"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingTrackingInformation = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../../constants");
const ShippingTrackingInformation = ({ shippingTracking, listNumber }) => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-order-details-shipping-tracking-container" },
        react_1.default.createElement("p", { className: "boutik-customer-account-order-details-shipping-tracking-carrier" }, `${t("customerAccount.orders.orderDetails.header.carrier")} ${listNumber ? t("customerAccount.orders.orderDetails.header.parcel", { parcelNumber: listNumber }) : " "} : ${shippingTracking.carrier}`),
        react_1.default.createElement("p", { className: "boutik-customer-account-order-details-shipping-tracking-number" }, `${t("customerAccount.orders.orderDetails.header.trackingNumber")}: ${shippingTracking.trackingNumber}`)));
};
exports.ShippingTrackingInformation = ShippingTrackingInformation;
//# sourceMappingURL=ShippingTrackingInformation.js.map